<template>
  <div id="pass37">
    <v-card class="ep-rechner-box">
      <v-col cols="12" class="p-0">
        <div class="v-card__title p-0">
          <h2 class="v-card--head--title">{{ selectedLang.StornoTile1 }}</h2>
        </div>
      </v-col>
      <v-card-text>
        <v-row>
          <v-col cols="12">
            <div class="v-card--msg">
              <h2 class="ep-rechner-h2">{{ stornoTile2 }}</h2>
            </div>
          </v-col>
        </v-row>
        <v-form ref="pcTRFForm" v-model="pcTRFFormValid" lazy-validation>
          <v-row>
            <v-col cols="12" sm="6">
              <p v-html="stornoTile3"></p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select attach v-model="anotherFlightTRF" :items="itemsJNT" :disabled="preChecked || pass37"
                item-text="state" :label="selectedLang.StornoTileLabel1"
                :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']" persistent-hint return-object single-line
                required></v-select>
            </v-col>
          </v-row>
          <v-row class="tooltipbox-storno-1">
            <v-col cols="12" sm="6">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                    <v-icon dark> mdi-help </v-icon>
                  </v-btn>
                </template>
                <span v-html="stornoTile7"></span>
              </v-tooltip>
            </v-col>
          </v-row>
          <template v-if="af915 &&
            dataFS.airline.name == 'Ryanair' &&
            anotherFlightTRF != ''
            ">
            <v-row>
              <v-col cols="12" sm="6">
                <p>
                  {{ selectedLang.StornoTile35 }}
                </p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-dialog attach v-model="datepickerTRFDOB" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on }">
                    <v-text-field v-model="computedDateTRFDOB" :label="selectedLang.StornoTile36" :rules="fldRules"
                      :disabled="pass37" persistent-hint prepend-icon="event" readonly v-on="on" required></v-text-field>
                  </template>
                  <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="doB" no-title :max="zbMaxDate"
                    @input="datepickerTRFDOB = false"></v-date-picker>
                </v-dialog>
              </v-col>
            </v-row>
          </template>
          <v-row v-if="anotherFlightTRF != ''">
            <v-col cols="12" sm="6">
              <p>
                {{ stornoTile9 }}
              </p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select attach v-model="wBooked" :items="itemsWB" :disabled="preChecked || pass37" item-text="state"
                :label="selectedLang.StornoTileLabel2" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                persistent-hint return-object single-line required></v-select>
            </v-col>
          </v-row>
          <v-row v-if="wBooked.val == 'bp'">
            <v-col cols="12" sm="6">
              <p v-html="stornoTile14"></p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select attach v-model="selectedBP" :items="bPortals" :disabled="preChecked || pass37" item-text="bPName"
                :label="selectedLang.StornoTileLabel3" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                persistent-hint return-object single-line :required="wBooked.val == 'bp'"></v-select>
            </v-col>
          </v-row>
          <template v-if="wBooked.val == 'bp' && selectedBP != ''">
            <v-row>
              <v-col cols="12" sm="5">
                <p v-html="stornoTile15"></p>
              </v-col>
              <v-col cols="12" sm="6" offset-sm="1">
                <v-select attach v-model="wHA" :items="itemsJN" :disabled="preChecked || pass37" item-text="state"
                  :label="StornoTileLabel5" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']" persistent-hint
                  return-object single-line :required="wBooked.val == 'bp'"></v-select>
              </v-col>
            </v-row>
            <v-row class="tooltipbox-storno-1">
              <v-col cols="12" sm="6">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                      <v-icon dark> mdi-help </v-icon>
                    </v-btn>
                  </template>
                  <span v-html="selectedLang.StornoTile16"></span>
                </v-tooltip>
              </v-col>
            </v-row>
          </template>
          <v-row v-if="(wBooked.val != 'bp' || (wBooked.val == 'bp' && wHA != '')) &&
            anotherFlightTRF != ''
            ">
            <v-col cols="12" sm="6">
              <p v-html="storText18"></p>
            </v-col>
            <v-col cols="12" sm="6">
              <v-select attach v-model="wBCF" :items="itemsJN" :disabled="preChecked || pass37" item-text="state"
                :label="selectedLang.StornoTileLabel6" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                persistent-hint return-object single-line required></v-select>
            </v-col>
          </v-row>
        </v-form>
        <template v-if="preChecked">
          <v-form ref="trfForm" v-model="trfFormValid" lazy-validation>
            <template v-if="selectedCase.valN == 3">
              <v-row>
                <v-col cols="12" sm="6">
                  <p>
                    {{ stornoTile20 }}
                  </p>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog attach v-model="datepickerTRF" :close-on-content-click="false" transition="scale-transition"
                    offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="computedDateTRF" :label="selectedLang.StornoTileLabel7" :rules="fldRules"
                        :disabled="pass37" persistent-hint prepend-icon="event" readonly v-on="on"
                        required></v-text-field>
                    </template>
                    <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="sD" no-title :max="maxflDTRF"
                      @input="datepickerTRF = false"></v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row class="tooltipbox-storno-2">
                <v-col cols="12" sm="6">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                        <v-icon dark> mdi-help </v-icon>
                      </v-btn>
                    </template>
                    <span v-html="stornoTile21"></span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
            <v-row v-if="computedDateTRF != ''">
              <v-col cols="12" sm="6">
                <p v-html="selectedLang.StornoTile22"></p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select attach v-model="bRF" :items="itemsJN" :disabled="pass37" item-text="state"
                  :label="selectedLang.StornoTileLabel8" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                  persistent-hint return-object single-line required></v-select>
              </v-col>
            </v-row>
            <v-row v-if="bRF.val == 'y'">
              <v-col cols="12" sm="6">
                <p>
                  {{ storText23 }}
                </p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select attach v-model="bRFS" :items="itemsJN" :disabled="pass37" item-text="state"
                  :label="selectedLang.StornoTileLabel9" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                  @change="calcFullPrice()" persistent-hint return-object single-line
                  :required="bRF.val == 'y'"></v-select>
              </v-col>
            </v-row>
            <template v-if="bRFS.val == 'y'">
              <v-row>
                <v-col cols="12" sm="6">
                  <p>
                    {{ selectedLang.StornoTile24 }}
                  </p>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-dialog attach v-model="datepickerTRFRF" :close-on-content-click="false" transition="scale-transition"
                    offset-y max-width="290px" min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field v-model="computedDateTRFRF" :label="selectedLang.StornoTileLabel10" :rules="fldRules"
                        :disabled="pass37" persistent-hint prepend-icon="event" readonly v-on="on"
                        :required="bRFS.val == 'y'"></v-text-field>
                    </template>
                    <v-date-picker :first-day-of-week="1" locale="de-DE" v-model="sDRF" :min="maxflDTRF" no-title
                      @input="datepickerTRFRF = false"></v-date-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6">
                  <p v-html="selectedLang.StornoTile25"></p>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="rfFlN" :disabled="pass37" :rules="flnRules"
                    :label="selectedLang.StornoTileLabel11" :required="bRFS.val == 'y'"></v-text-field>
                </v-col>
              </v-row>
            </template>
            <v-row v-if="showSelC && !dataFS.airline.isRW6" id="pass77">
              <v-col cols="12" sm="6">
                <p v-html="storText26a"></p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select attach v-model="pKnown" :items="itemsJN" :disabled="pass37" item-text="state"
                  :label="selectedLang.StornoTile26f" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                  persistent-hint return-object single-line required></v-select>
              </v-col>
            </v-row>
            <template v-if="pKnown.val == 'n' || (showSelC && dataFS.airline.isRW6)">
              <v-row>
                <v-col cols="12" sm="5">
                  <p v-html="storText26b"></p>
                </v-col>
                <v-col cols="12" sm="6" offset-sm="1">
                  <v-text-field v-model="fullPrice" prepend-icon="mdi-currency-eur" :disabled="pass37"
                    :rules="fullPriceRules" :label="selectedLang.StornoTileLabel26g"
                    :required="pKnown.val == 'n'"></v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="fullPrice != ''">
                <v-col cols="12" sm="5">
                  <p v-html="selectedLang.StornoTile26e"></p>
                </v-col>
                <v-col cols="12" sm="6" offset-sm="1">
                  <v-text-field v-model="nOfTraveler" prepend-icon="mdi-account" :disabled="pass37" :rules="travelerRules"
                    :label="selectedLang.StornoTileLabel26h" :required="pKnown.val == 'n'"></v-text-field>
                </v-col>
              </v-row>
            </template>
            <v-row v-if="pKnown.val == 'y' || nOfTraveler != ''">
              <v-col cols="12">
                <!-- <p v-html="storText27"></p> -->
                  <v-alert outlined color="info" transition="scale-transition" class="text-center" v-html="storText27"></v-alert>
              </v-col>
              <v-col cols="12" sm="6" offset-sm="6">
                <v-alert v-if="editedRefund" type="warning" elevation="2">{{ selectedLang.StornoTile37 }}
                </v-alert>
                <v-text-field v-model="refund" prepend-icon="mdi-currency-eur" :disabled="pass37" :rules="refundRules"
                  :label="selectedLang.StornoTileLabel12" required></v-text-field>
              </v-col>
            </v-row>
            <v-row v-if="pKnown.val == 'y'" class="tooltipbox-storno-3">
              <v-col cols="12" sm="6" class="p-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                      <v-icon dark> mdi-help </v-icon>
                    </v-btn>
                  </template>
                  <span v-html="selectedLang.StornoTile28"></span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row v-if="dataFS.airline.trfSB == '1' && trfSB2C && pKnown.val == 'y'">
              <v-col cols="12">
                <v-alert type="warning" elevation="2">{{ selectedLang.StornoTile40 }}
                </v-alert>
              </v-col>
              <v-col cols="12" sm="6">
                <p v-html="selectedLang.StornoTile41"></p>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select attach v-model="breakdownKnown" :items="itemsJN" :disabled="pass37" item-text="state"
                  :label="selectedLang.StornoTile43" :rules="[(v) => !!v || selectedLang.StornoTileRule2 + '']"
                  persistent-hint return-object single-line></v-select>
              </v-col>
            </v-row>
            <v-row v-if="dataFS.airline.trfSB == '1' && trfSB2C && pKnown.val == 'y'" class="tooltipbox-storno-4">
              <v-col cols="12" sm="6" class="p-0">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn x-small color="#022c54" fab dark v-bind="attrs" v-on="on">
                      <v-icon dark> mdi-help </v-icon>
                    </v-btn>
                  </template>
                  <span>{{
                    formatDBText(selectedLang.StornoTile42, {
                      airlineName: dataFS.airline.name,
                    })
                  }}</span>
                </v-tooltip>
              </v-col>
            </v-row>
            <v-row v-if="dataFS.airline.trfSB == '1' && trfSB2C && pKnown.val == 'y'">
              <v-col v-if="breakdownKnown.val == 'y'" cols="12" sm="6">
                <p v-html="selectedLang.StornoTile44"></p>
              </v-col>
              <v-col v-if="breakdownKnown.val == 'y'" cols="12" sm="6">
                <v-text-field v-model="refundWOF" prepend-icon="mdi-currency-eur" :disabled="pass37" :rules="refundRules"
                  :label="selectedLang.StornoTile45" required></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </template>
      </v-card-text>

      <v-card-actions>
        <v-row v-if="selectedDiv == '37' && !preChecked">
          <v-col cols="12">
            <v-btn id="confirm-reas" block :disabled="wBCF == ''" class="btn-ep-next-step" @click="preCheck37()">{{
              selectedLang.StornoTile30 }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv == '37' && preChecked">
          <v-col cols="12">
            <v-btn id="confirm-reas" block :disabled="refund == ''" class="btn-ep-next-step" @click="check37()">{{
              selectedLang.StornoTile30 }}</v-btn>
          </v-col>
        </v-row>
        <v-row v-if="selectedDiv != '37' && !noChange">
          <v-col cols="12">
            <v-btn id="goto--reas" block class="btn-ep-back-to" @click="backToSpecificTile('37')">{{
              selectedLang.ReasonTile130 }}</v-btn>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
import dayjs from "dayjs";
export default {
  name: "StornoTile",
  data: function () {
    return {
      anotherFlightTRF: "",
      fullPrice: "",
      pKnown: "",
      nOfTraveler: "",
      wBooked: "",
      selectedBP: "",
      wHA: "",
      wBCF: "",
      bRF: "",
      bRFS: "",
      preChecked: false,
      datepickerTRFDOB: false,
      datepickerTRF: false,
      datepickerTRFRF: false,
      pcTRFFormValid: false,
      trfFormValid: false,
      SuG2H: false,
      sDRF: "",
      doB: "",
      sD: this.$store.state.maxflDTRF,
      rfFlN: "",
      refund: 0,
      refund2C: "",
      trfSB2C: false,
      tempR2C: 0,
      stoText27: "",
      editedRefund: false,
      sameAirIATA: false,
      breakdownKnown: "",
      isCheapAir: false,
      refundWOF: 0,
      origRefund: 0,
      bPortals: [],
      itemsJNT: [
        {
          state: this.$store.state.selectedLang.StornoTile4,
          val: "y",
          bool: false,
        },
        {
          state: this.$store.state.selectedLang.StornoTile4a,
          val: "y",
          bool: false,
        },
        {
          state: this.$store.state.selectedLang.StornoTile5,
          val: "n",
          bool: true,
        },
        {
          state: this.$store.state.selectedLang.StornoTile6,
          val: "hs",
          bool: true,
        },
      ],
      fullPriceRules: [
        (v) => !!v || this.$store.state.selectedLang.StornoTileRule1 + "",
        (v) =>
          /^[-+]?[0-9]*[.,]?[0-9]+$/.test(v) ||
          this.$store.state.selectedLang.StornoTileRule1 + "",
      ],
      travelerRules: [
        (v) => !!v || this.$store.state.selectedLang.StornoTile26i + "",
        (v) =>
          /^\d+$/.test(v) || this.$store.state.selectedLang.StornoTile26i + "",
      ],
      fldRules: [
        (v) => !!v || this.$store.state.selectedLang.StornoTileRule3 + "",
      ],
      stornoTile2: "",
      stornoTile3: "",
      stornoTile7: "",
      stornoTile9: "",
      stornoTile10: "",
      stornoTile11: "",
      stornoTile14: "",
      stornoTile15: "",
      stornoTile18: "",
      stornoTile18a: "",
      stornoTile20: "",
      stornoTile21: "",
      stornoTile31: "",
      stornoTile32: "",
      stornoTile33: "",
      stornoTile34: "",
      itemsWB: [],
    };
  },
  watch: {
    refund() {
      if (this.selectedCase.valN != 7) {
        let firstC = false;
        this.calcRef(this.refund, firstC);
      }
    },
    nOfTraveler() {
      this.calcFullPrice();
    },
    fullPrice() {
      this.calcFullPrice();
    },
    bRF() {
      this.bRFS = "";
      if (this.pKnown.val == "n" || this.dataFS.airline.isRW6) {
        this.calcFullPrice();
      }
    },
    bRFS() {
      if (this.bRFS.val == "y") {
        this.rfFlN = this.dataFS.flN.substring(0, 2);
      } else {
        this.rfFlN = "";
      }
    },
    rfFlN() {
      if (
        this.dataFS.airline.name == "Ryanair" &&
        (this.rfFlN.substring(0, 2) == "FR" ||
          this.rfFlN.substring(0, 2) == "RK" ||
          this.rfFlN.substring(0, 3) == "RYR")
      ) {
        this.sameAirIATA = true;
      } else if (
        this.dataFS.airline.name == "easyJet" &&
        (this.rfFlN.substring(0, 2) == "U2" ||
          this.rfFlN.substring(0, 3) == "EZY" ||
          this.rfFlN.substring(0, 3) == "EJU")
      ) {
        this.sameAirIATA = true;
      } else if (
        this.dataFS.flN.substring(0, 2) == this.rfFlN.substring(0, 2)
      ) {
        this.sameAirIATA = true;
      } else {
        this.sameAirIATA = false;
      }
    },
    breakdownKnown() {
      if (this.breakdownKnown.val == "n") {
        this.pKnown = { state: "Nein", val: "n" };
        this.goToStep({ vm: this, val: "77" });
      }
    },
    refundWOF() {
      let firstC = true;
      this.calcRef(this.refundWOF, firstC);
    },
    pKnown() {
      this.breakdownKnown = "";
      this.fullPrice = "";
      this.nOfTraveler = "";
      this.refund = 0;
      this.refundWOF = 0;
    },
  },
  computed: {
    ...mapState([
      "selectedLang",
      "itemsJN",
      "pass37",
      "selectedDiv",
      "flN",
      "dataEP",
      "dataTrain",
      "noChange",
      "maxflDTRF",
      "zbMaxDate",
      "af915",
      "selectedCase",
      "dataFS",
    ]),
    computedDateTRF() {
      return this.formatDate(this.sD);
    },
    computedDateTRFRF() {
      return this.formatDate(this.sDRF);
    },
    computedDateTRFDOB() {
      return this.formatDate(this.doB);
    },
    flnRules() {
      return [
        (v) => !!v || this.selectedLang.FirstFlightTile7 + "",
        (v) =>
          this.flN.toLowerCase() != v.toLowerCase() ||
          this.selectedLang.StornoTile25a + "",
        (v) =>
          /^[0-9]{0,1}[A-Za-z]{1,3}\s*[0-9]{1,5}\s*$/.test(v) ||
          this.selectedLang.FirstFlightTile7 + "",
        this.sameAirIATA || this.selectedLang.StornoTile25b + "",
      ];
    },
    refundRules() {
      return [
        (v) => !!v || this.$store.state.selectedLang.StornoTileRule1 + "",
        (v) =>
          /^[-+]?[0-9]*[.,]?[0-9]+$/.test(v) ||
          this.$store.state.selectedLang.StornoTileRule1 + "",
        !this.SuG2H || this.$store.state.selectedLang.StornoTile37a + "",
      ];
    },
    storText27() {
      let stornoextent = "";
      if (this.bRFS.val == "y") {
        stornoextent = this.selectedLang.StornoTile39;
      } else {
        stornoextent = this.selectedLang.StornoTile38;
      }
      if (this.pKnown.val == "n" || this.dataFS.airline.isRW6) {
        return this.formatDBText(this.selectedLang.StornoTile26d, {
          stornoextent: stornoextent,
        });
      } else {
        return this.formatDBText(this.selectedLang.StornoTile27, {
          stornoextent: stornoextent,
        });
      }
    },
    storText26a() {
      let stornoextent = "";
      if (this.bRFS.val == "y") {
        stornoextent = this.selectedLang.StornoTile39;
      } else {
        stornoextent = this.selectedLang.StornoTile38;
      }
      return this.formatDBText(this.selectedLang.StornoTile26a, {
        stornoextent: stornoextent,
      });
    },
    storText26b() {
      let stornoextent = "";
      if (this.bRFS.val == "y") {
        stornoextent = this.selectedLang.StornoTile39;
      } else {
        stornoextent = this.selectedLang.StornoTile38;
      }
      return this.formatDBText(this.selectedLang.StornoTile26b, {
        stornoextent: stornoextent,
      });
    },
    storText23() {
      let stornoextent = "";
      if (this.selectedCase.valN == 4) {
        stornoextent = this.selectedLang.StornoTile23b;
      } else if (this.selectedCase.valN == 3) {
        stornoextent = this.selectedLang.StornoTile23a;
      } else if (this.selectedCase.valN == 5) {
        stornoextent = this.selectedLang.StornoTile23;
      }
      return stornoextent;
    },
    storText18() {
      let stornoextent = "";
      if (this.selectedCase.valN != 7) {
        if (this.dataFS.airline.fs == "FR") {
          stornoextent = this.stornoTile18a;
        } else {
          stornoextent = this.stornoTile18;
        }
      } else {
        stornoextent = this.stornoTile18a;
      }
      return stornoextent;
    },
    showSelC() {
      if (
        this.bRF.val == "n" ||
        this.bRFS.val == "n" ||
        (this.bRFS.val == "y" && this.rfFlN != "")
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
  mounted: async function () {
    if (this.selectedCase.valN == 7) {
      this.stornoTile2 = this.$store.state.selectedLang.StornoTile2DB;
      this.stornoTile3 = this.$store.state.selectedLang.StornoTile3DB;
      this.stornoTile7 = this.$store.state.selectedLang.StornoTile7DB;
      this.stornoTile9 = this.$store.state.selectedLang.StornoTile9DB;
      this.stornoTile10 = this.$store.state.selectedLang.StornoTile10DB;
      this.stornoTile11 = this.$store.state.selectedLang.StornoTile11DB;
      this.stornoTile14 = this.$store.state.selectedLang.StornoTile14DB;
      this.stornoTile15 = this.$store.state.selectedLang.StornoTile15DB;
      this.stornoTile18 = this.$store.state.selectedLang.StornoTile18DB;
      this.stornoTile18a = this.$store.state.selectedLang.StornoTile18aDB;
      this.stornoTile20 = this.$store.state.selectedLang.StornoTile20DB;
      this.stornoTile21 = this.$store.state.selectedLang.StornoTile21DB;
      this.stornoTile31 = this.formatDBText(
        this.$store.state.selectedLang.StornoTile31DB,
        { bookingCode: this.dataTrain.bookingCode }
      );
      this.stornoTile32 = this.$store.state.selectedLang.StornoTile32DB;
      this.stornoTile33 = this.$store.state.selectedLang.StornoTile33DB;
      this.stornoTile34 = this.$store.state.selectedLang.StornoTile34DB;
      this.wHA = this.$store.state.itemsJN[1];
      this.wBCF = this.$store.state.itemsJN[1];
    } else {
      this.stornoTile2 = this.$store.state.selectedLang.StornoTile2;
      this.stornoTile3 = this.$store.state.selectedLang.StornoTile3;
      this.stornoTile7 = this.$store.state.selectedLang.StornoTile7;
      this.stornoTile9 = this.$store.state.selectedLang.StornoTile9;
      this.stornoTile10 = this.$store.state.selectedLang.StornoTile10;
      this.stornoTile11 = this.$store.state.selectedLang.StornoTile11;
      this.stornoTile14 = this.$store.state.selectedLang.StornoTile14;
      this.stornoTile15 = this.$store.state.selectedLang.StornoTile15;
      this.stornoTile18 = this.$store.state.selectedLang.StornoTile18;
      this.stornoTile18a = this.$store.state.selectedLang.StornoTile18a;
      this.stornoTile20 = this.$store.state.selectedLang.StornoTile20;
      this.stornoTile21 = this.$store.state.selectedLang.StornoTile21;
      this.stornoTile31 = this.formatDBText(
        this.$store.state.selectedLang.StornoTile31,
        { "this.flN": this.flN }
      );
      this.stornoTile32 = this.$store.state.selectedLang.StornoTile32;
      this.stornoTile33 = this.$store.state.selectedLang.StornoTile33;
      this.stornoTile34 = this.$store.state.selectedLang.StornoTile34;
      if (
        this.dataFS.airline.fs == "FR" ||
        this.dataFS.airline.fs == "U2" ||
        this.dataFS.airline.fs == "W6" ||
        this.dataFS.airline.fs == "TR"
      ) {
        this.isCheapAir = true;
      }
    }
    this.itemsWB = [
      {
        state: this.stornoTile10,
        val: "al",
        bool: true,
      },
      {
        state: this.stornoTile11,
        val: "bp",
        bool: true,
      },
      {
        state: this.$store.state.selectedLang.StornoTile12,
        val: "ta",
        bool: false,
      },
      {
        state: this.$store.state.selectedLang.StornoTile13,
        val: "to",
        bool: false,
      },
    ];
    if (this.selectedCase.valN == 7) {
      fetch(
        "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getBookingPortalsDB.php"
      )
        .then((res) => res.json())
        .then((res) => {
          this.bPortals = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          this.wBooked = this.itemsWB[0];
        });
    } else {
      fetch(
        "https://www.ersatz-pilot.de/wp-content/themes/ep_new/calculator/scripts/getBookingPortals.php"
      )
        .then((res) => res.json())
        .then((res) => {
          this.bPortals = res;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally();
    }
  },
  methods: {
    ...mapActions([
      "backToSpecificTile",
      "goToStep",
      "setSelectedDiv",
      "setVar",
    ]),
    preCheck37() {
      if (this.$refs.pcTRFForm.validate()) {
        if (
          !this.anotherFlightTRF.bool ||
          this.wBCF.val == "y" ||
          (!this.wBooked.bool && !this.isCheapAir) ||
          this.wHA.val == "y"
        ) {
          if (!this.wBooked.bool) {
            this.$store.state.rejectionMessage = this.stornoTile32;
          } else if (this.wBCF.val == "y") {
            this.$store.state.rejectionMessage = this.stornoTile34;
          } else if (this.wHA.val == "y") {
            this.$store.state.rejectionMessage = this.stornoTile33;
          } else if (!this.anotherFlightTRF.bool) {
            this.$store.state.rejectionMessage = this.selectedLang.AirLineNotificationTile8a;
          } else {
            this.$store.state.rejectionMessage = this.stornoTile31;
          }
          this.setSelectedDiv("32");
          this.setVar({ pos: "pass37", val: true });
        } else {
          if (this.selectedCase.valN == 7) {
            var faktN = 0.8;
            var ustRate, sevenPerce = 0;
            let tanspr, provi;
            let ust = 0;
            let margetotal = 0;

            ustRate = parseFloat(
              this.dataTrain.price.toString().replace(",", ".")
            ).toFixed(2);

            if (this.dataTrain.kiof == "six") {
              if (
                this.dataTrain.trCancelDirection != "both" &&
                this.dataTrain.nOfRides == 2
              ) {
                ustRate = ustRate / 2;
                if (ustRate.toFixed(2) > ustRate) {
                  ustRate = ustRate - 0.005;
                }
              }
            } else {
              if (
                this.dataTrain.trCancelDirection == "outward"
              ) {
                ustRate = parseFloat(
                  this.dataTrain.priceDetails.outward.toString().replace(",", ".")
                ).toFixed(2);
              } else if (this.dataTrain.trCancelDirection == "return") {
                ustRate = parseFloat(
                  this.dataTrain.priceDetails.return.toString().replace(",", ".")
                ).toFixed(2);
              }
            }

            var refundbase = (ustRate / 107) * 7;
            this.dataEP.refundbase = refundbase.toFixed(2)
              .toString()
              .replace(".", ",");

            if (ustRate <= 20.00) {
              sevenPerce = 6.25;
            } else if (ustRate > 20.00 && ustRate <= 40.00) {
              sevenPerce = (ustRate * 0.25);
              if (sevenPerce <= 6.25) {
                sevenPerce = 6.25;
              }
            } else if (ustRate > 40.00 && ustRate <= 185.00) {
              sevenPerce = 12.50;
            } else {
              sevenPerce = ((sevenPerce / 107) * 7);
            }

            this.dataEP.refund = sevenPerce
              .toFixed(2)
              .toString()
              .replace(".", ",");

            this.refund2C = sevenPerce;
            this.refund = sevenPerce;

            this.dataEP.refund2C = this.refund2C;

            tanspr = this.refund2C * faktN;
            provi = this.refund2C - tanspr;

            margetotal = parseFloat(provi / 1.19);
            ust = parseFloat(provi - margetotal);
            provi = margetotal;

            this.dataEP.provi = provi.toFixed(2).toString().replace(".", ",");
            this.dataEP.ust = ust.toFixed(2).toString().replace(".", ",");
            this.dataEP.anspr = tanspr.toFixed(2).toString().replace(".", ",");

            var travelDateArr = this.dataTrain.travelDate.split(".");
            this.dataEP.sD = this.formatDate(
              travelDateArr[2] + "-" + travelDateArr[1] + "-" + travelDateArr[0]
            );

            this.dataEP.sDRF = this.formatDate(this.sDRF);
            this.dataEP.selectedBP = this.selectedBP;
            this.dataEP.wBooked = this.wBooked.val;
            this.dataEP.editedRefund = this.editedRefund;
            this.dataEP.pKnown = "n";
            this.dataEP.fullPrice = this.dataTrain.price;
            this.dataEP.trfTraveler = this.dataTrain.nOPa;
            this.setVar({ pos: "dataEP", val: this.dataEP });
            this.setVar({ pos: "pass37", val: true });
            this.setVar({ pos: "trfTraveler", val: this.nOfTraveler });
            this.setSelectedDiv("40");
            this.goToStep({ vm: this, val: this.selectedDiv });
            this.$gtag.event("4d. Storno-Angaben bestaetigt", {
              event_category: "Rechner",
              event_label: "4d. Storno-Angaben bestaetigt",
            });
          } else {
            this.preChecked = true;
          }
        }
      }
    },
    check37() {
      if (this.$refs.trfForm.validate()) {
        var faktN = 0.8;
        let tanspr;
        let provi;
        let ust = 0;
        let margetotal = 0;

        const date2 = dayjs(this.doB);
        const d907 = dayjs("2021-09-07");
        const d907Diff = d907.diff(date2, "day");

        if (d907Diff <= 0) {
          this.setVar({ pos: "newAGB", val: true });
        }

        var pFullPrice = parseFloat(
          this.fullPrice.toString().replace(",", ".")
        ).toFixed(2);

        if (this.refund2C > parseFloat(pFullPrice)) {
          this.refund2C = pFullPrice;
          this.refund = pFullPrice;
        }

        this.dataEP.refund2C = this.refund2C;

        tanspr = this.refund2C * faktN;
        provi = this.refund2C - tanspr;

        if (this.dataEP.t1.iy) {
          margetotal = parseFloat(provi);
          ust = 0;
        } else {
          margetotal = parseFloat(provi / 1.19);
          ust = parseFloat(provi - margetotal);
        }
        provi = margetotal;

        this.dataEP.provi = provi.toFixed(2).toString().replace(".", ",");
        this.dataEP.ust = ust.toFixed(2).toString().replace(".", ",");
        this.dataEP.anspr = tanspr.toFixed(2).toString().replace(".", ",");
        this.dataEP.rfFlN = this.rfFlN.toUpperCase().trim();
        this.dataEP.sD = this.formatDate(this.sD);
        this.dataEP.sDRF = this.formatDate(this.sDRF);
        this.dataEP.selectedBP = this.selectedBP;
        this.dataEP.wBooked = this.wBooked.val;

        if (this.refundWOF != 0) {
          this.dataEP.refund = this.refundWOF.toString().replace(".", ",");
          this.dataEP.origRefund = this.refund.toString().replace(".", ",");
        } else {
          this.dataEP.refund = this.refund.toString().replace(".", ",");
        }
        this.dataEP.editedRefund = this.editedRefund;
        if (this.pKnown == "") {
          this.pKnown = { state: "Nein", val: "n" };
        }
        this.dataEP.pKnown = this.pKnown.val;
        this.dataEP.fullPrice = this.fullPrice;
        this.dataEP.trfTraveler = this.nOfTraveler;
        this.setVar({ pos: "dataEP", val: this.dataEP });
        this.setSelectedDiv("40");
        this.setVar({ pos: "pass37", val: true });
        this.setVar({ pos: "trfTraveler", val: this.nOfTraveler });
        this.goToStep({ vm: this, val: this.selectedDiv });
        this.$gtag.event("4d. Storno-Angaben bestaetigt", {
          event_category: "Rechner",
          event_label: "4d. Storno-Angaben bestaetigt",
        });
      }
    },
    formatDBText(str, values) {
      let result;
      let reg = /(\w+.?\w+)(?= }})/g;
      while ((result = reg.exec(str)) !== null) {
        let key = String(str).match(reg)[0];
        if (Object.keys(values).includes(key)) {
          str = str.replace("{{ " + key + " }}", values[key]);
        }
      }
      result = str;
      return result;
    },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}.${month}.${year}`;
    },
    calcRef(val, firstC) {
      this.refund2C = parseFloat(val.toString().replace(",", ".")).toFixed(2);
      if (this.refund2C > 200 || firstC) {
        this.trfSB2C = true;
      } else {
        this.trfSB2C = false;
      }
      let intedtR2C = parseFloat(this.tempR2C);
      let intedR2C = parseFloat(this.refund2C);
      let calcDifference = intedR2C - intedtR2C;
      let compareEpsilon = 0.01;
      if (calcDifference > compareEpsilon && this.dataFS.airline.isRW6) {
        if (intedR2C > parseFloat(this.fullPrice)) {
          this.SuG2H = true;
        } else {
          this.SuG2H = false;
        }
        this.editedRefund = true;
      } else {
        this.editedRefund = false;
        this.SuG2H = false;
      }
    },
    calcFullPrice() {
      var feeTaxes = 0;
      if (this.bRFS.val == "y") {
        feeTaxes =
          parseFloat(this.dataEP.trfSugT) + parseFloat(this.dataEP.trfSugB);
      } else {
        feeTaxes = parseFloat(this.dataEP.trfSugT);
      }
      var tempNOfT = this.nOfTraveler == "" ? 1 : parseInt(this.nOfTraveler);
      var result = tempNOfT * feeTaxes;
      var pFullPrice = parseFloat(
        this.fullPrice.toString().replace(",", ".")
      ).toFixed(2);
      if (result > pFullPrice) {
        this.refund = pFullPrice;
      } else {
        this.refund = result.toFixed(2);
      }
      this.tempR2C = this.refund;
    },
  },
};
</script>
